<template>
    <div class="lms__superadmin_users_bulk_actions_remove_from_groups_select_users_table">
        <component-table
            :checkbox="true"
            :checkbox-name="'bulk-add-user-to-group-item'"
            :checkbox-by-key="'profileId'"
            :list-emit-name="'bulk-add-user-to-group-item'"
            :labels="tableLabels"
            :items="items"
            :selected="selected"
            :component-table-item="LmsSuperadminUsersBulkActionsRemoveFromGroupsSelectUsersTableItem"
            @emit-sort="handleSort"
            @emit-check="handleEmitCheck"
        />
    </div>
</template>

<script>
import ComponentTable from '@/components/default/shared/ComponentTable'
import LmsSuperadminUsersBulkActionsRemoveFromGroupsSelectUsersTableItem from '@/components/lms/superadmin/users/bulk/actions/removefromgroups/LmsSuperadminUsersBulkActionsRemoveFromGroupsSelectUsersTableItem'

export default {
  name: 'lms-superadmin-users-bulk-actions-remove-from-groups-select-users-table',
  components: { ComponentTable },
  data () {
    return {
      LmsSuperadminUsersBulkActionsRemoveFromGroupsSelectUsersTableItem
    }
  },
  props: {
    items: {
      type: Array
    },
    selected: {
      type: [Array, Object]
    }
  },
  computed: {
    tableLabels () {
      let itemsArr = []

      itemsArr.push({
        key: 'firstName',
        title: 'First name',
        type: 'string',
        sortable: true,
        queryable: true
      })
      itemsArr.push({
        key: 'lastName',
        title: 'Last name',
        type: 'string',
        sortable: true,
        queryable: true
      })
      itemsArr.push({
        key: 'emailAddress',
        title: 'Email address',
        type: 'string',
        sortable: true,
        queryable: true
      })
      itemsArr.push({
        key: 'roles',
        title: 'Role',
        type: 'string'
      })
      itemsArr.push({
        key: 'orgUnits',
        title: 'Org unit',
        type: 'string'
      })
      itemsArr.push({
        key: 'groups',
        title: 'Group',
        type: 'string'
      })
      itemsArr.push({
        key: 'status',
        title: 'Status',
        type: 'string',
        sortable: true,
        queryable: true
      })

      return itemsArr
    }
  },
  methods: {
    handleSort (data) {
      this.$emit('emit-sort', data)
    },
    handleEmitCheck (data) {
      this.$emit('emit', { message: 'emit-check', value: data })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminusersbulkactionsremovefromgroupsselectuserstable.scss";
</style>
